/**
 * Canonical Home Screen tile art (Rocket Launcher / PWA).
 * Black-outlined ae squircle — same asset as manifest icons.
 * Do not substitute public/ae-mark.png (plain mark without tile border).
 */
export const HOME_SCREEN_TILE_SRC = '/icons/icon-192.png'
